import React from "react";

function NoMatchPage() {
  const containerStyles = {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundImage: "url(../notFound.svg)",
    backgroundPosition: "center",
    backgroundSize: "cover",
  };

  const text = {
    margin: "0px",
    padding: "0px",
    color: "white",
    fontSize: "3rem",
    textAlign: "center",
  };

  return (
    <div style={containerStyles}>
      <h3 style={text}>404 - Not found ☹</h3>
    </div>
  );
}

export default NoMatchPage;
